/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CatalogItemId,
  CreateMaterialRequest,
  GetMaterialParams,
  ListMaterialsParams,
  MaterialDto,
  PaginatedMaterialDto,
  UpdateMaterialRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListMaterialsUrl = (params: ListMaterialsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/materials?${stringifiedParams}`
    : `/api/v1/engineering/materials`;
};

/**
 * @summary List materials
 */
export const listMaterials = async (
  params: ListMaterialsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedMaterialDto> => {
  return customFetch<PaginatedMaterialDto>(getListMaterialsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateMaterialUrl = () => {
  return `/api/v1/engineering/materials`;
};

/**
 * @summary Create material
 */
export const createMaterial = async (
  createMaterialRequest: CreateMaterialRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CatalogItemId> => {
  return customFetch<CatalogItemId>(getCreateMaterialUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createMaterialRequest),
  });
};

export const getGetMaterialUrl = (id: CatalogItemId, params?: GetMaterialParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/materials/${id}?${stringifiedParams}`
    : `/api/v1/engineering/materials/${id}`;
};

/**
 * @summary Get material
 */
export const getMaterial = async (
  id: CatalogItemId,
  params?: GetMaterialParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MaterialDto> => {
  return customFetch<MaterialDto>(getGetMaterialUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateMaterialUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/materials/${id}`;
};

/**
 * @summary Update material
 */
export const updateMaterial = async (
  id: CatalogItemId,
  updateMaterialRequest: UpdateMaterialRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateMaterialUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateMaterialRequest),
  });
};

export const getDeleteMaterialUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/materials/${id}`;
};

/**
 * @summary Delete material
 */
export const deleteMaterial = async (
  id: CatalogItemId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteMaterialUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreMaterialUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/materials/${id}/restore`;
};

/**
 * @summary Restore material
 */
export const restoreMaterial = async (
  id: CatalogItemId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreMaterialUrl(id), {
    ...options,
    method: "POST",
  });
};
